import { render, staticRenderFns } from "./subsidiary.vue?vue&type=template&id=41c6a642&"
import script from "./subsidiary.vue?vue&type=script&lang=js&"
export * from "./subsidiary.vue?vue&type=script&lang=js&"
import style0 from "./subsidiary.vue?vue&type=style&index=0&id=41c6a642&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports